import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { AuthService, GlobalMessageType } from '@spartacus/core'
import { Observable } from 'rxjs'
import { AccountSummaryService } from '../../../services/account/account-summary.service'
import { CustomGlobalMessageService } from '../../../services/shared/custom-global-message/custom-global-message.service'

@Component({
    selector: 'app-custom-site-context-selector',
    templateUrl: './custom-site-context-selector.component.html',
    styleUrls: ['./custom-site-context-selector.component.scss'],
    standalone: false
})
export class CustomSiteContextSelectorComponent implements OnInit {
  public b2bUnit$: Observable<any>
  public isLoggedIn$: Observable<boolean>

  constructor(
    private accountSummaryService: AccountSummaryService,
    private changeDetectorRef: ChangeDetectorRef,
    public globalMessageService: CustomGlobalMessageService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isUserLoggedIn()
    this.b2bUnit$ = this.accountSummaryService.getAllOrgUnits()
  }

  public changeOrgUnit(orgUnit: string): void {
    this.accountSummaryService.changeOrgUnits(orgUnit).subscribe(
      () => {
        this.globalMessageService.add(
          { key: 'accountSummary.b2bSelectorChanged' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION
        )
        setTimeout(() => {
          location.reload()
        }, 1000)
      },
      (err) => {
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
      }
    )
  }
}
